/**
 * @file paddlejs demo
 * @author wanzhongyun
 */

 import { useRef, useState } from 'react';
 import Camera from '@paddlejs-mediapipe/camera';
 import * as humanseg from '@paddlejs-models/humanseg';

const useJSExample = (setModelStatus: any, currentImage: { readonly current: string }) => {

    const videoRef = useRef<HTMLVideoElement>(null);
    const demoRef = useRef<HTMLCanvasElement>(null);
    const [loadingStatus, setLoadingStatus] = useState<boolean>(false);

    let timer: any = null;
    const videoDomStatusFunc = async() => {
        if (videoRef.current && demoRef.current) {
            // 调用一下摄像头，等待用户访问权限
            navigator.mediaDevices.getUserMedia({video: true});

            const videoCanvas: HTMLCanvasElement = document.createElement('canvas');
            const videoCanvasCtx = videoCanvas.getContext('2d');
            await load(videoCanvas, videoCanvasCtx);

            videoRef.current?.addEventListener('loadeddata', async() => {
                clearTimeout(timer);
                setLoadingStatus(false);
                setModelStatus(false);
                camera.start();
            });

        }
        else {
            timer = setTimeout(() => videoDomStatusFunc(), 50);
        }
    };


    let camera: any = null;
    const closeFunc = () => {
        camera.pause();
        camera.stream.getTracks()[0].stop();
    };
    
    const load = async(videoCanvas: HTMLCanvasElement, videoCanvasCtx: CanvasRenderingContext2D | null) => {
        await humanseg.load();
        const defaultWidth = 500;
        const defaultHeight = 280;
        if (videoRef.current) {
            camera = new Camera(videoRef.current, {
                mirror: true,
                enableOnInactiveState: true,
                onFrame: async () => {
                    videoCanvas.width = videoRef.current?.width || defaultWidth;
                    videoCanvas.height = videoRef.current?.height || defaultHeight;
                    videoCanvasCtx?.drawImage(videoRef.current as CanvasImageSource, 0, 0, videoCanvas.width, videoCanvas.height);
                    const {
                        data
                    } = await humanseg.getGrayValue(videoCanvas);
                    // canvas画背景图
                    const background_canvas = document.createElement('canvas');
                    background_canvas.width = defaultWidth;
                    background_canvas.height = defaultHeight;
                    const img = new Image();
                    img.src = currentImage.current;
                    img.onload = () => {
                        background_canvas.getContext('2d')?.drawImage(img, 0, 0, background_canvas.width, background_canvas.height);
                    };
                    humanseg.drawHumanSeg(data, demoRef.current, background_canvas);
                }
            });
        }
    };

    return {
        camera,
        videoRef,
        demoRef,
        loadingStatus,
        closeFunc,
        setLoadingStatus,
        videoDomStatusFunc
    }
};

export default useJSExample;